"use client"
import Link from "next/link";
import EduHeader from "../edu/Header";
import AgentTabs from "./AgentTabs";
import Login from "../modal/Login";
import Register from "../modal/Register";
import { IData, IBus } from "@/types";
import { AI_ROLE } from "@/constants";
import { fetchAgentViewList } from "@/hooks/useData";
import { Toaster } from 'react-hot-toast';
import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import BgFloatImages from "./BgFloatImages";
gsap.registerPlugin(ScrollToPlugin);

export default function StudentHome({ data, lang, bus, templateId }: { data: IData, lang: string, bus: IBus, templateId: string | number }) {
  // 获取模型
  function getModel() {
    const model = AI_ROLE.filter(item => data.modelList.includes(item.id))
    return model
  }

  const modelList = getModel();
  const [agentViewList, setAgentViewList] = useState<any[]>([]);
  const sectionsRef = useRef<HTMLDivElement[]>([]);
  const [current, setCurrent] = useState(0);
  const isScrolling = useRef(false);

  const mapId: Record<string, number> = {
    'xzmf': 4,
    'xingmo': 6,
  }

  useEffect(() => {
    fetchAgentViewList(data.id).then(res => {
      setAgentViewList(res);
    });
  }, [data.id]);

  useEffect(() => {
    const onWheel = (e: WheelEvent) => {
      if (isScrolling.current) return;
      if (e.deltaY > 0 && current < 1) {
        scrollToSection(current + 1);
      } else if (e.deltaY < 0 && current > 0) {
        scrollToSection(current - 1);
      }
    };
    window?.addEventListener('wheel', onWheel, { passive: false });
    return () => window?.removeEventListener('wheel', onWheel);
  }, [current]);

  function scrollToSection(idx: number) {
    if (!sectionsRef.current[idx]) return;
    isScrolling.current = true;
    gsap.to(window, {
      duration: 0.5,
      scrollTo: { y: sectionsRef.current[idx], autoKill: false },
      onComplete: () => {
        setCurrent(idx);
        isScrolling.current = false;
      }
    });
  }

  return (
    <div className="bg-[#FAFCFF] w-full min-h-full">
      <div className="pl-6 pr-4 w-full fixed top-0 left-0 z-[30] bg-white lg:py-5 lg:bg-transparent">
        <EduHeader data={data}>
          <Link href="/">
            <img src={data?.homeLogoUrl || data?.logoUrl} className="h-[60px]" />
          </Link>
        </EduHeader>
      </div>
      <div ref={el => { sectionsRef.current[0] = el!; }} className="section w-full flex flex-col items-center justify-center pt-[117px] lg:pt-0 lg:h-screen z-10 relative">
        {/* Section 1: 图片 */}
        <div className="w-full  flex items-center justify-center flex-col lg:h-full">
          <div className="max-w-[600px] px-[30px] w-full max-h-[270px] relative">
            <img src="/images/logoBG.png" className=" object-cover lg:h-full" />
            <img src="/images/logomotion.gif" className="h-full absolute top-0 pointer-events-none" />
          </div>
          <Link href="/chat" className="w-[168px] h-[56px] text-base text-white flex items-center justify-center bg-[#303133] rounded-full mt-10 hover:bg-[#303133]/80 cursor-pointer">开始使用</Link>

        </div>
        <div
          className="items-center flex-col justify-center mt-auto mb-4 animate-bounce cursor-pointer hidden lg:flex"
          onClick={() => scrollToSection(1)}
        >
          <span className="text-[#909399] text-sm">继续滑</span>
          <span className="font_family icon-a-Arrow_Forward2 rotate-90 text-2xl! text-[#303133]"></span>
        </div>
      </div>

      <div ref={el => { sectionsRef.current[1] = el!; }} className="section w-full flex flex-col items-center justify-center section-2 relative z-10 lg:h-screen px-2.5 lg:px-0">
        <div className="flex-1 flex items-center justify-center w-full">
          <div className="w-full ">
            <AgentTabs data={agentViewList} />
          </div>
        </div>
      </div>
      <Register data={data} />
      <Login />
      <Toaster />
      <div className="hidden lg:block">
        <BgFloatImages sectionIndex={current} />
      </div>
      <div className="lg:hidden block">
        <img src="/images/student/student-bg.png" className="w-full h-full fixed inset-0" />
      </div>
    </div>
  );
}
